export default function FullWidthBanner() {
  return (
    <section className="w-full">
      {/* Palermo Banner */}
      <div className="relative w-full overflow-hidden cursor-pointer mb-8">
        <img 
          src="https://images.puma.net/images/fn/%7Eregional%7ETUR%7Eothers%7EKOP%7EAW25%7ENovember+Home+Page%7Epalermo_fullbleed-jpeg.jpg"
          alt="PALERMO"
          className="w-full h-auto object-cover"
        />
        <div className="absolute inset-0 flex flex-col items-start justify-center px-8 md:px-16 lg:px-24">
          <h2 className="text-white text-5xl md:text-7xl font-bold mb-4">PALERMO</h2>
          <p className="text-white text-xl md:text-2xl mb-8">SAHALARDAN SOKAKLARA</p>
          <button className="bg-white text-black px-8 py-3 font-bold hover:bg-gray-200 transition whitespace-nowrap cursor-pointer">
            ALIŞVERİŞE BAŞLA
          </button>
        </div>
      </div>

      {/* Border Banner */}
      <div className="w-full mb-8">
        <img 
          src="https://tr.puma.com/media/contentmanager/content/border_v3.jpg"
          alt="Border"
          className="w-full h-auto object-cover"
        />
      </div>

      {/* PUMA FAM Banner */}
      <div className="w-full bg-red-600 cursor-pointer">
        <img 
          src="https://tr.puma.com/media/contentmanager/content/pumafam_2000x300_homepage_banner_1.jpg"
          alt="PUMA FAM ÜYESİ OL, İLK SİPARİŞİNDE %15 İNDİRİM KAZAN"
          className="w-full h-auto object-cover"
        />
      </div>
    </section>
  );
}
